import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MutiSelect({
    id,
    getValue,
    sizeCbb = 'small',
    valueSelect = [],
    label,
    selectOption = [],
    displayLabel = 'label',
    disabled = false,
    valueEqual = 'value',
}) {
    const [value, setValue] = React.useState([]);
    function filterUniqueObjects(array) {
        const uniqueObjects = array.reduce((acc, curr) => {
            if (!acc[curr[valueEqual]]) {
                acc[curr[valueEqual]] = curr;
            }
            return acc;
        }, {});

        return Object.values(uniqueObjects);
    }
    const handleOnChange = (event, value) => {
        setValue(filterUniqueObjects(value));
        getValue && getValue(filterUniqueObjects(value));
    };

    return (
        <Autocomplete
            multiple
            id={id}
            options={selectOption}
            size={sizeCbb}
            value={valueSelect ? valueSelect.filter((depart) => depart[valueEqual] !== 1) : value}
            disabled={disabled}
            // defaultValue={valueSelect}
            fullWidth
            disableCloseOnSelect
            onChange={handleOnChange}
            getOptionLabel={(option) => option[displayLabel]}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    {/* {console.log('option', option)} */}
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={(valueSelect ? valueSelect : value).some(
                            (object) => object.value === option[valueEqual]
                        )}
                    />
                    {option[displayLabel]}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            )}
        />
    );
}
